export class ConfigUtils {
  static parseConfig (config) {
    const {
      show_bookings_button: showBookingsButton,
      show_gpu_plannings: showGpuPlannings = false,
      documentation_url: documentationUrl,
      viewers_documentation_url: viewersDocumentationUrl,
      show_temporal_tab: showTemporalTab,
      show_change_email_button: showChangeEmailButton,
      http_port: httpPort,
      https_port: httpsPort,
      bastion_domain: bastionDomain,
      bastion_ssh_port: bastionSshPort,
      can_use_bastion: canUseBastion,
      can_use_bastion_individual_domains: canUseBastionIndividualDomains,
      frontend_mode: frontendMode = 'deprecated',
      faro = { enabled: false, url: null },
      session: {
        id = '',
        max_renew_time: maxRenewTime = 0,
        max_time: maxTime = 0
      } = {}
    } = config
    return {
      showBookingsButton,
      showGpuPlannings,
      documentationUrl,
      viewersDocumentationUrl,
      showTemporalTab,
      showChangeEmailButton,
      httpPort,
      httpsPort,
      bastionDomain,
      bastionSshPort,
      canUseBastion,
      canUseBastionIndividualDomains,
      frontendMode,
      faro,
      session: {
        id,
        maxRenewTime,
        maxTime
      }
    }
  }
}
